import { object, string } from 'yup';

export default object().shape({
  firstName: string().required('First name is required'),
  lastName: string().required('Last name is required'),
  phone: string()
    .required('Phone number is required'),
    // .matches(
    //   /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
    //   'Phone number should be XXX-XXX-XXXX format'
    // ),
  password: string()
    .required('Password is required')
    .min(6, 'Password should be at least 6 letters'),
});
